/**
 * Utility to identify if a form field label or name represents a seaport / port location
 * (e.g. "Port", "Arrival Port", "Departure Port", "Next Port", "Port of Registry"),
 * while excluding false positives such as "Report", "Passport", "Port Stay Hours", "Port ME", etc.
 */
export function isPortField(labelOrName?: string | null): boolean {
  if (!labelOrName || typeof labelOrName !== 'string') return false

  const text = labelOrName.trim().toLowerCase()

  // Exclude false positive words
  if (
    text.includes('report') ||
    text.includes('passport') ||
    text.includes('support') ||
    text.includes('viewport') ||
    text.includes('transport') ||
    text.includes('portion') ||
    text.includes('portfolio')
  ) {
    return false
  }

  // Exclude machinery / duration / non-port fields
  if (
    text.includes('port stay') ||
    text.includes('port hours') ||
    text.includes('port days') ||
    text.includes('port consumption') ||
    text.includes('port me') ||
    text.includes('port gen') ||
    text.includes('port side') ||
    text.includes('portside') ||
    text.includes('shackles port')
  ) {
    return false
  }

  // Check for whole word "port"
  return /\bports?\b/i.test(text)
}
